// extracted by mini-css-extract-plugin
export default {"pageholder":"ConnexionComponent_pageholder__XqlIE"};